export const branchesData = [
  {
    id: 'unit-1',
    unitNumber: 'Unit 1',
    name: 'Chettipalayam JJ Nagar',
    fullName: 'IDOL FITNESS ZONE — Unit 1 (Chettipalayam JJ Nagar)',
    badge: 'Main Branch',
    address: 'JJ Nagar, Chettipalayam, Coimbatore, Tamil Nadu',
    instagram: 'https://www.instagram.com/idol_fitness_zone?igsi=MXFnYm40aXR3a2d1Ng==',
    instaHandle: '@idol_fitness_zone',
    mapsUrl: 'https://maps.app.goo.gl/ka4UwvNt5fxsjoDz7?g_st=ipc',
    phone: '73395 04861',
    whatsapp: 'https://wa.me/917339504861',
    timing: '5:00 AM – 10:00 PM (Mon–Sat)',
    features: ['Olympic Free Weights', 'Cardio Floor', 'Personal Coaching', 'Locker Facility']
  },
  {
    id: 'unit-2',
    unitNumber: 'Unit 2',
    name: 'Pappampatti Pirivu',
    fullName: 'IDOL FITNESS ZONE — Unit 2 (Pappampatti Pirivu)',
    badge: 'Unit 2',
    address: 'Pappampatti Pirivu, Coimbatore, Tamil Nadu',
    instagram: 'https://www.instagram.com/idol_fitnesszone2?utm_source=qr&igsi=enFwMHRpbGxwYmQw',
    instaHandle: '@idol_fitnesszone2',
    mapsUrl: 'https://maps.app.goo.gl/ax5vhgLVrXVe3jX18',
    phone: '73395 04861',
    whatsapp: 'https://wa.me/917339504861',
    timing: '5:00 AM – 10:00 PM (Mon–Sat)',
    features: ['Modern Heavy Machinery', 'Functional Cross-Training', 'Unisex Fitness Zone', 'Diet Consultation']
  },
  {
    id: 'unit-3',
    unitNumber: 'Unit 3',
    name: 'Peedampalli',
    fullName: 'IDOL FITNESS ZONE — Unit 3 (Peedampalli)',
    badge: 'Unit 3',
    address: 'Peedampalli, Coimbatore, Tamil Nadu',
    instagram: 'https://www.instagram.com/idol_fitness_zone?igsi=MXFnYm40aXR3a2d1Ng==',
    instaHandle: '@idol_fitness_zone',
    mapsUrl: 'https://maps.app.goo.gl/HihacAjQDSiAcC1M6?g_st=iwb',
    phone: '90474 77177',
    whatsapp: 'https://wa.me/919047477177',
    timing: '5:00 AM – 10:00 PM (Mon–Sat)',
    features: ['Powerlifting Racks', 'Endurance Cardio Zone', 'Body Transformation', 'Certified Trainers']
  }
];
